import { techniciansOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { usersToMemberEdit } from "../helpers/utils";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("technician"),
  endpoint: "technicians",
  operations: techniciansOps,
  roleView: [ROLE.APP_SERVICE_USER, ROLE.APP_SERVICE_USER],
  roleAdmin: [ROLE.APP_SERVICE_USER],
  singularName: (t) => t("Technician"),
  name: (t) => t("Technicians"),
  infiniteNormalizer: (value) => ({
    rowCount: value.rowCount,
    first: value.first,
    results: usersToMemberEdit(value.results ?? []),
  }),
  sendCulture: true,
  dependencies: ["contract"],
  syncCustomerFilter: true,
});

export default conf;
